import {
  ADD_GROUP_COURSE,
  ADD_GROUP_COURSE_SUCCESS,
  ADD_GROUP_COURSE_CLEAN,
  ADD_GROUP_COURSE_ERROR,
} from "./actionTypes"

export const addGroupCourse = form => ({
  type: ADD_GROUP_COURSE,
  payload: { form },
})

export const addGroupCourseSuccess = group => {
  return {
    type: ADD_GROUP_COURSE_SUCCESS,
    payload: { group },
  }
}

export const addGroupCourseClean = () => {
  return {
    type: ADD_GROUP_COURSE_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: ADD_GROUP_COURSE_ERROR,
    payload: error,
  }
}
